export default __webpack_public_path__ + "a505a2c359d29a1da8729459a66709b3.png";